import { z } from 'zod';

export const shippingCalculateSchema = z.object({
  postalCode: z.string().regex(/^\d{4}-\d{3}$/, 'Código postal inválido'),
  totalWeightGrams: z.number().int().nonnegative(),
  orderSubtotal: z.number().nonnegative(),
});

export const shippingZoneCreateSchema = z.object({
  name: z.string().min(1).max(100),
  description: z.string().max(255).nullable().optional(),
  postalPrefixes: z.array(z.string().min(1).max(4)).min(1),
  isActive: z.boolean().default(true),
});

export const shippingZoneUpdateSchema = shippingZoneCreateSchema.partial();

export const shippingRateCreateSchema = z.object({
  zoneId: z.string().uuid(),
  name: z.string().min(1).max(100),
  minWeightG: z.number().int().nonnegative().default(0),
  maxWeightG: z.number().int().positive(),
  price: z.number().nonnegative(),
  estimatedDays: z.string().max(50).nullable().optional(),
  isActive: z.boolean().default(true),
});

export const shippingRateUpdateSchema = shippingRateCreateSchema.partial();

export const freeShippingCampaignCreateSchema = z.object({
  name: z.string().min(1).max(150),
  minOrderAmount: z.number().nonnegative().nullable().optional(),
  startsAt: z.string().datetime(),
  endsAt: z.string().datetime(),
  zoneIds: z.array(z.string().uuid()).default([]),
  isActive: z.boolean().default(true),
});

export const freeShippingCampaignUpdateSchema = freeShippingCampaignCreateSchema.partial();

export type ShippingCalculateInput = z.infer<typeof shippingCalculateSchema>;
export type ShippingZoneCreateInput = z.infer<typeof shippingZoneCreateSchema>;
export type ShippingRateCreateInput = z.infer<typeof shippingRateCreateSchema>;
export type FreeShippingCampaignCreateInput = z.infer<typeof freeShippingCampaignCreateSchema>;

// ─── Public shipping info (the /entregas-e-devolucoes page) ──────────
// Rendered from the zones and rates the store actually has configured in the
// backoffice, so the published delivery costs can never drift from the ones
// charged at checkout.

export interface PublicShippingRate {
  id: string;
  name: string;
  price: string;
  estimatedDays: string | null;
  minWeightG: number;
  maxWeightG: number;
}

export interface PublicShippingZone {
  id: string;
  name: string;
  description: string | null;
  rates: PublicShippingRate[];
}

export interface PublicShippingInfo {
  zones: PublicShippingZone[];
  /** Lowest order total that ships free right now, if a campaign is running. */
  freeShippingFrom: string | null;
}
